import React from 'react';
import cc from 'classcat';
import {
  AnchorButton as BPAnchorButton,
  AnchorButtonProps as IAnchorButtonProps
} from '@blueprintjs/core';

import './button.scss';

/**
 * Extends Blueprint's AnchorButton
 * https://blueprintjs.com/docs/#core/components/button.props
 *
 * Overcomes focus issue that when <Button disabled />
 * is a child of <Tooltip />
 */

interface AnchorButtonProps extends IAnchorButtonProps {
  bare?: boolean;
}

const AnchorButton: React.FC<AnchorButtonProps> = ({
  children,
  bare,
  className,
  ...props
}) => {
  const classes = cc([
    className ? className : undefined,
    bare ? 'bare' : 'not-bare'
  ]);
  return (
    <BPAnchorButton className={classes} {...props}>
      {children}
    </BPAnchorButton>
  );
};

export default AnchorButton;
